import React, { useState } from 'react'
import {ChevronLeft, ChevronRight, Quote} from 'lucide-react'

const testimonials = [
  {
    name: 'John D.',
    role: 'CEO',
    company: 'Tech Solutions Inc.',
    text: 'Triangle Project Consultants transformed our approach to project management. Their strategic insights and hands-on guidance helped us complete a major initiative ahead of schedule and under budget.',
    rating: 5
  },
  {
    name: 'Robin S.',
    role: 'COO',
    company: 'Global Manufacturing',
    text: 'The process optimization consulting we received from Triangle Project Consultants has resulted in a 30% increase in operational efficiency. Their team\'s expertise and collaborative approach made all the difference.',
    rating: 5
  },
  {
    name: 'Robert J.',
    role: 'Director of IT',
    company: 'Financial Services Group',
    text: 'We engaged Triangle Project Consultants for a complex digital transformation project. Their strategic guidance and risk management expertise were invaluable in navigating challenges and delivering exceptional results.',
    rating: 5
  }
]

export default function Testimonials() {
  const [current, setCurrent] = useState(0)

  const next = () => setCurrent((current + 1) % testimonials.length)
  const prev = () => setCurrent((current - 1 + testimonials.length) % testimonials.length)

  return (
    <div className="py-24 bg-slate-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            What Our Clients Say
          </h2>
          <p className="text-xl text-gray-400">
            Hear from organizations that have transformed their project outcomes with our services
          </p>
        </div>

        <div className="relative max-w-4xl mx-auto">
          {/* Testimonial Card */}
          <div className="bg-gradient-to-br from-slate-800 to-slate-900 border border-slate-700 rounded-2xl p-8 md:p-12 relative">
            <Quote className="w-12 h-12 text-cyan-400/20 absolute top-8 left-8" />
            
            <div className="relative z-10">
              <div className="flex mb-4">
                {[...Array(testimonials[current].rating)].map((_, i) => (
                  <svg key={i} className="w-5 h-5 text-amber-400" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                ))}
              </div>

              <p className="text-xl text-gray-300 mb-8 leading-relaxed">
                "{testimonials[current].text}"
              </p>

              <div className="flex items-center">
                <div className="w-12 h-12 bg-gradient-to-br from-cyan-400 to-emerald-400 rounded-full flex items-center justify-center text-white font-bold text-lg">
                  {testimonials[current].name.charAt(0)}
                </div>
                <div className="ml-4">
                  <div className="font-bold text-white">{testimonials[current].name}</div>
                  <div className="text-gray-400 text-sm">{testimonials[current].role} • {testimonials[current].company}</div>
                </div>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <div className="flex justify-center items-center space-x-4 mt-8">
            <button onClick={prev} className="w-12 h-12 bg-slate-800 hover:bg-slate-700 border border-slate-700 rounded-full flex items-center justify-center transition">
              <ChevronLeft className="w-6 h-6 text-white" />
            </button>
            
            <div className="flex space-x-2">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrent(index)}
                  className={`w-2 h-2 rounded-full transition ${index === current ? 'bg-cyan-400 w-8' : 'bg-slate-700'}`}
                />
              ))}
            </div>

            <button onClick={next} className="w-12 h-12 bg-slate-800 hover:bg-slate-700 border border-slate-700 rounded-full flex items-center justify-center transition">
              <ChevronRight className="w-6 h-6 text-white" />
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
